<template>
    <div>
        <!--daas 简介-->
        <sec-about-daas-widget :matte-data="package.matteData" />

        <!--表单填写-->
        <sec-form-widget v-bind="package" />
    </div>
</template>

<script>
    import SecAboutDaasWidget from "@/components/sec-about-daas-widget"
    import SecFormWidget from "@/components/sec-form-widget"

    export default {
        name: "sec-header-widget",
        components: {
            SecAboutDaasWidget,
            SecFormWidget
        },
        props: ["package"]
    }
</script>


// WEBPACK FOOTER //
// src/components/sec-footer-widget.vue